import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import AdminCalendarPage from './pages/AdminCalendarPage';
import SchoolCalendarPage from './pages/SchoolCalendarPage';
import Header from './components/Header';

function ProtectedRoute({ children, adminOnly = false }: { children: React.ReactNode; adminOnly?: boolean }) {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <div className="container" style={{ textAlign: 'center', marginTop: '100px' }}>Laden...</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (adminOnly && user.role !== 'admin') {
    return <Navigate to="/agenda" replace />;
  }

  return <>{children}</>;
}

function AppRoutes() {
  const { user, isLoading } = useAuth();

  if (isLoading) {
    return <div className="container" style={{ textAlign: 'center', marginTop: '100px' }}>Laden...</div>;
  }

  return (
    <Routes>
      <Route path="/login" element={user ? <Navigate to={user.role === 'admin' ? '/admin' : '/agenda'} replace /> : <LoginPage />} />
      <Route path="/register" element={user ? <Navigate to={user.role === 'admin' ? '/admin' : '/agenda'} replace /> : <RegisterPage />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute adminOnly>
            <>
              <Header />
              <AdminCalendarPage />
            </>
          </ProtectedRoute>
        }
      />
      <Route
        path="/agenda"
        element={
          <ProtectedRoute>
            <>
              <Header />
              <SchoolCalendarPage />
            </>
          </ProtectedRoute>
        }
      />
      <Route path="/" element={<Navigate to={user?.role === 'admin' ? '/admin' : user ? '/agenda' : '/login'} replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
